// import React, { useEffect, useState } from 'react'
import * as R from 'ramda'
import sys from './globalFunction'
import { serverUrl } from '../config'
import tremApi from './tremApi'
import { bool } from 'prop-types'

const setSessinInfo = () => tremApi('/session/info/load/make/session').then(obj => {
    let UserInfo = null

    if(obj != null){
        UserInfo = obj.UserInfo
    }

    return UserInfo
})


const getSessinInfo = () => setSessinInfo().then( data => {
  return data
})

const getUserSkey = () => setSessinInfo().then(data => {

    let USER_SKEY = null

    if(data != null){
        USER_SKEY = data.USER_SKEY
    }
    
    return USER_SKEY
})

const getEquipRoomSkey = () => setSessinInfo().then(data => {

    let EQ_ROOM_SKEY = null

    if(data != null){
        EQ_ROOM_SKEY = data.EQ_ROOM_SKEY
    }
    
    return EQ_ROOM_SKEY
})

const getEquipRoomList = () => setSessinInfo().then(data => {

    let EQ_ROOM_SKEYS = null

    if(data != null){
        EQ_ROOM_SKEYS = data.EQ_ROOM_SKEYS
    }
    
    return EQ_ROOM_SKEYS
})

const isLogin = () => setSessinInfo().then(data => {
    return data.loggined
})

const setRmSessionInfo = () => {
    return tremApi('/user/logout').then(obj => {
        return obj?.loggined
    })
}

export default {
     getSessinInfo
    ,getUserSkey
    ,getEquipRoomSkey
    ,getEquipRoomList
    ,isLogin
    ,setRmSessionInfo
}